/*
  +--------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     动态路由视图映射
  +--------------------------------------------------------------------------------------
*/

// 自动导入 @/views 文件夹下所有后缀为 .vue 的文件
const dynamicViewsMap = {}
const re = /([^/]*)\.vue$/

const apViews = require.context('@/views/ap/', false, /\.vue$/)
const datavViews = require.context('@/views/datav/', false, /\.vue$/)
const devViews = require.context('@/views/dev/', false, /\.vue$/)
const eiViews = require.context('@/views/ei/', false, /\.vue$/)
const expenseViews = require.context('@/views/expense/', false, /\.vue$/)
const famViews = require.context('@/views/fam/', false, /\.vue$/)
const fncViews = require.context('@/views/fnc/', false, /\.vue$/)
const rmsViews = require.context('@/views/rms/', false, /\.vue$/)
const upViews = require.context('@/views/up/', false, /\.vue$/)
const prmViews = require.context('@/views/prm/', false, /\.vue$/)
const emViews = require.context('@/views/em/', false, /\.vue$/)

apViews.keys().forEach(function (item) {
  const key = item.match(re)[1]
  dynamicViewsMap[key] = () => import('@/views/ap/' + key + '.vue')
})
datavViews.keys().forEach(function (item) {
  const key = item.match(re)[1]
  dynamicViewsMap[key] = () => import('@/views/datav/' + key + '.vue')
})
devViews.keys().forEach(function (item) {
  const key = item.match(re)[1]
  dynamicViewsMap[key] = () => import('@/views/dev/' + key + '.vue')
})
eiViews.keys().forEach(function (item) {
  const key = item.match(re)[1]
  dynamicViewsMap[key] = () => import('@/views/ei/' + key + '.vue')
})
expenseViews.keys().forEach(function (item) {
  const key = item.match(re)[1]
  dynamicViewsMap[key] = () => import('@/views/expense/' + key + '.vue')
})
famViews.keys().forEach(function (item) {
  const key = item.match(re)[1]
  dynamicViewsMap[key] = () => import('@/views/fam/' + key + '.vue')
})
fncViews.keys().forEach(function (item) {
  const key = item.match(re)[1]
  dynamicViewsMap[key] = () => import('@/views/fnc/' + key + '.vue')
})
rmsViews.keys().forEach(function (item) {
  const key = item.match(re)[1]
  dynamicViewsMap[key] = () => import('@/views/rms/' + key + '.vue')
})
upViews.keys().forEach(function (item) {
  const key = item.match(re)[1]
  dynamicViewsMap[key] = () => import('@/views/up/' + key + '.vue')
})
prmViews.keys().forEach(function (item) {
  const key = item.match(re)[1]
  dynamicViewsMap[key] = () => import('@/views/prm/' + key + '.vue')
})
emViews.keys().forEach(function (item) {
  const key = item.match(re)[1]
  dynamicViewsMap[key] = () => import('@/views/em/' + key + '.vue')
})



export default dynamicViewsMap
